import React, { useEffect, useRef, useState } from 'react';
import Circle from './components/Circle';
import Project from './components/Project';
import { links } from './components/js/projects.js';
// import Fibonacci from './components/Fibonacci';
import './App.css';
// import './App.scss';
import $ from 'jquery'; // alias for jQuery

const App = () => {
  const [state, setState] = useState({
    react: false,
    angular: false,
    typescript: false,
    html5: false,
    css3: false,
    net: false,
    SQL: false,
    lens: true,
    subtitle: '|',
    top_form: false,
    contact_btn_text: "Let's work together!"
  });

  const skills = ['react', 'angular', 'typescript', 'html5', 'css3', 'NET', 'SQL'];
  const showSkillsRef = useRef(null);

    const addLetter = (index = 0, subtitle = '') => {
    const full = 'Web Developer | Designer '.split('');
    if (index >= full.length) {
      setState(prev => ({
        ...prev,
        react: true,
        angular: true,
        typescript: true,
        html5: true,
        css3: true,
        NET: true,
        SQL: true
      }));
      return;
    }
    const current = subtitle + full[index];
    setState(prev => ({ ...prev, subtitle: current }));
    setTimeout(() => addLetter(index + 1, current), 75);
  };
  useEffect(() => {
    setTimeout(() => addLetter(0, ''), 750);
  }, []);

  const timeout = (time) =>
    new Promise((resolve) => {
      setTimeout(() => {
        setState(prev => ({ ...prev, react: true, lens: true }));
        resolve();
      }, time);
    });

  const scrollSkills = (count) => {
    $('.skills').css('width', '100%');
    const skill = skills[count];
    const old = skills[count - 1] || skills[skills.length - 1];
    setState(prev => ({
      ...prev,
      [old]: false,
      [skill]: true
    }));
  };

  const startScroll = async (time) => {
    await timeout(time);
    let count = 1;
    showSkillsRef.current = setInterval(() => {
      scrollSkills(count);
      count = (count + 1) % skills.length;
    }, 1000);
  };

  const clearAllSkills = () => {
    clearInterval(showSkillsRef.current);
    const cleared = {};
    for (const key of skills) {
      cleared[key] = false;
    }
    setState(prev => ({ ...prev, ...cleared }));
  };

    const letsWorkTogether = (e) => {
    e.preventDefault();
    $(e.target).addClass('work_clicked');
    setState(prev => ({ ...prev, contact_btn_text: false }));
    setTimeout(() => {
      $('.work_clicked').addClass('work_expand');
      setTimeout(() => {
        setState(prev => ({ ...prev, top_form: true }));
      }, 1000);
    }, 750);
  };

  const topFormClose = () => {
    setState(prev => ({ ...prev, top_form: false }));
    $('.work_with').removeClass('work_expand').removeClass('work_clicked');
    setTimeout(() => {
      setState(prev => ({ ...prev, contact_btn_text: true }));
    }, 550);
  };

  // ...inside return(
  const form = ( state.top_form )?(
      <div className="top_form">
        <div className="top_form_close" onClick={topFormClose}>x</div>
        <form className = "form" id = "contact-form" method = "POST" action="https://formspree.io/josh@allenb.com">
        <h1>Let's get started.</h1>
        <h4>After introducing yourself and describing your project, I'll get in touch and schedule a time for us to talk in more detail. Or, contact me directly at <a href="mailto:joshfost@gmail.com">joshfost@gmail.com.</a></h4>
          <div className = "form-group">
            <input placeholder="Name*" className="form-control" type = "text" name = "name" id = "name"/>
          </div>
          <div className = "form-group">
            <input placeholder="email*" className="form-control" type = "text" name = "email" id = "email"/>
          </div>
          <div className = "form-group">
            <input placeholder="phone" className="form-control" type = "text" name = "phone" id = "phone"/>
          </div>
          <div className = "form-group">
            <textarea placeholder="Describe your project. What do you want to create, and why? How can I be of assistance in making it happen?" className="form-control" name = "message" id = "details"></textarea>
          </div>
          <div className="hidden">
            <label htmlFor = "address">Address </label>
            <input name = "address" id = "address"/>
          </div>
          <div className = "form-group">
            <button className="form-control btn btn-primary" type="submit" >Send</button>
          </div>
          <p>&#42;&nbsp;required fields</p>
        </form>
      </div>
    ) : '';
return (
  <div id="top">
    {state.top_form && 
      form
    }
    <header>
      <div className="title-bkg">
        <div className="title-text container-fluid">
          <div className="lead col-sm-12">
            <img width="75px" src='./photos/Josh_logo_red.png' />
            <div className="main_name">Josh Foster</div>
            <div className="main_name_subtitle">{state.subtitle}</div>
            <div onClick={letsWorkTogether} className="work_with">
              {state.contact_btn_text ? "Let's work together" : ''}
            </div>
          </div>
        </div>
      </div>
    </header>

    <main className="clearfix">
      <div className="portfolio container lead" id="portfolio">
        <div className="row circle_row">
          <div className="skills">

            {skills.map(skill => (
              <Circle
                key={skill}
                id={skill}
                brand={skill.charAt(0).toUpperCase() + skill.slice(1)}
                url={`./photos/${skill}-logo.png`}
                expanding={state[skill]}
                lens={state.lens}
                clearColors={() => setState(prev => ({ ...prev, lens: false }))}
                clearInterval={clearAllSkills}
              />
            ))}
          </div>
        </div>
        {links.map((proj, i) => (
          <div key={`project${i + 1}`}>
            <Project number={i + 1} project={proj} />
          </div>
        ))}
      </div>
    </main>

    <footer className="nav-footer lead">
      <ul>
        <a href="https://www.linkedin.com/in/joshfoster-dev"><li>LinkedIn&nbsp;<i className="fa fa-linkedin-square"></i></li></a>
        <a href="https://github.com/CloudEntity57?tab=repositories"><li>GitHub&nbsp;<i className="fa fa-github"></i></li></a>
      </ul>
    </footer>
  </div>
);
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js